import { render, staticRenderFns } from "./cityAreaList.vue?vue&type=template&id=0ec8601c&scoped=true"
import script from "./cityAreaList.vue?vue&type=script&lang=js"
export * from "./cityAreaList.vue?vue&type=script&lang=js"
import style0 from "./cityAreaList.vue?vue&type=style&index=0&id=0ec8601c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec8601c",
  null
  
)

export default component.exports